import { render, staticRenderFns } from "./itemclasificacion-form.vue?vue&type=template&id=7f87c580&scoped=true"
import script from "./itemclasificacion-form.vue?vue&type=script&lang=js"
export * from "./itemclasificacion-form.vue?vue&type=script&lang=js"
import style0 from "./itemclasificacion-form.vue?vue&type=style&index=0&id=7f87c580&prod&scoped=true&lang=css"
import style1 from "./itemclasificacion-form.vue?vue&type=style&index=1&id=7f87c580&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f87c580",
  null
  
)

export default component.exports